var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { columns } from "./column/column";
import React, { useEffect, useState } from "react";
import { getClientStaffAccounts } from "../../../api/marketData/clientStaff";
import { AonButton } from "../../../components/core/AonButton";
import { BUTTON_VARIANT } from "../../../components/core/AonButton/consts";
import { useClientPageStore, useErrorStore } from "../../../store";
import { ClientStaffAddDailog } from "../../Dailog/ClientStaffAddDailog";
import { observer } from "mobx-react";
import { ClientStaffRemoveDailog } from "../../Dailog/ClientStaffRemoveDialog";
import { useNavigate } from "react-router-dom";
import AonAgGridTable from "../../../components/core/AonAgGridTable/table";
export var ClientStaffContent = observer(function (props) {
    var _a = useState([]), clientListAccounts = _a[0], SetClientListAccounts = _a[1];
    var _b = useState(false), showConfirmation = _b[0], setShowConfirmation = _b[1];
    var _c = useState(false), addDailog = _c[0], setAddDailog = _c[1];
    var clientStore = useClientPageStore();
    var _d = useState(false), isLoading = _d[0], setIsLoading = _d[1];
    var navigation = useNavigate();
    var errorStore = useErrorStore();
    var _e = React.useState({
        currentPage: 1,
        totalDatacount: undefined,
        pagesize: 100,
        year: "",
        searchText: "",
        sortColumn: "",
        sortBy: "DESC"
    }), pageConfig = _e[0], setPageConfig = _e[1];
    useEffect(function () {
        if (props.selectedClientGuuid && props.activeTab === 2) {
            fetchData();
        }
    }, [props.activeTab, props.selectedClientGuuid, pageConfig.currentPage, pageConfig.pagesize, pageConfig.year, pageConfig.searchText]);
    var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var clientStaffContent, _clientListAccount, totalCount_1, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    setIsLoading(true);
                    return [4 /*yield*/, getClientStaffAccounts({ ClientGuid: props.selectedClientGuuid, Page: pageConfig.currentPage, PageSize: pageConfig.pagesize })];
                case 1:
                    clientStaffContent = _a.sent();
                    _clientListAccount = clientStaffContent.data.value.map(function (item) { return (__assign(__assign({}, item), { selected: true })); });
                    totalCount_1 = clientStaffContent.headers["x-total-count"];
                    setPageConfig(function (prev) { return (__assign(__assign({}, prev), { totalDatacount: totalCount_1 })); }); //settting up the total data count;
                    // console.log(_clientListAccount)
                    SetClientListAccounts(_clientListAccount);
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _a.sent();
                    console.log(error_1);
                    errorStore.showError({ message: "Error", code: "500" });
                    navigation('/error');
                    return [3 /*break*/, 4];
                case 3:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var onClickSelected = function (event, index) {
        event.preventDefault();
        var _clientStaffList = __spreadArray([], clientListAccounts, true);
        _clientStaffList[index].selected = !_clientStaffList[index].selected;
        SetClientListAccounts(_clientStaffList);
    };
    var handlePageChangeRequest = function (page) {
        page = page.detail.page;
        setPageConfig(function (prev) {
            return (__assign(__assign({}, prev), { currentPage: page }));
        });
    };
    var isRemovedEnabled = clientStore.isUserHaveFullAccess && clientListAccounts.filter(function (item) { return !item.selected; }).length > 0;
    var _f = useState(window.innerHeight), currentInneHeight = _f[0], setcurrentInneHeight = _f[1];
    useEffect(function () {
        var updateSize = function () {
            var innerHeight = window.innerHeight;
            setcurrentInneHeight(innerHeight);
        };
        window.addEventListener("resize", updateSize);
        return function () {
            window.removeEventListener("resize", updateSize);
        };
    }, []);
    var handleColumnSorting = function (sortColumn) {
        var revertSortBy = function (sBy) { return sBy === "DESC" ? "ASC" : "DESC"; };
        if (sortColumn === pageConfig.sortColumn) {
            setPageConfig(function (prev) {
                return (__assign(__assign({}, prev), { sortColumn: sortColumn, sortBy: revertSortBy(pageConfig.sortBy) }));
            });
        }
        else {
            setPageConfig(function (prev) {
                return (__assign(__assign({}, prev), { sortColumn: sortColumn, sortBy: "DESC" }));
            });
        }
        var tempData = __spreadArray([], clientListAccounts, true);
        var reverseSort = revertSortBy(pageConfig.sortBy);
        tempData = tempData.sort(function (a, b) {
            if (a[sortColumn] < b[sortColumn]) {
                return reverseSort === "ASC" ? -1 : +1;
            }
            else if (a[sortColumn] > b[sortColumn]) {
                return reverseSort === "ASC" ? +1 : -1;
            }
            else
                return 0;
        });
        SetClientListAccounts(__spreadArray([], tempData, true));
    };
    return (React.createElement("div", { className: "client-list-box", style: { minHeight: "1000px" } },
        React.createElement("div", { className: "addFilter" },
            React.createElement(AonButton, { disabled: !clientStore.isUserHaveFullAccess, style: { paddingInline: "5px" }, variant: BUTTON_VARIANT.DEFAULT, onClick: function () { setAddDailog(true); } }, "Add"),
            React.createElement(AonButton, { disabled: !isRemovedEnabled, style: { paddingInline: "5px" }, variant: BUTTON_VARIANT.DEFAULT, onClick: function () { return setShowConfirmation(true); } }, "Remove")),
        React.createElement("div", { className: "spacer" },
            React.createElement(AonAgGridTable, { rowData: clientListAccounts, height: currentInneHeight, columns: columns(onClickSelected, pageConfig.sortBy, pageConfig.sortColumn, handleColumnSorting, isLoading), loading: isLoading, pagination: true, currentPage: pageConfig.currentPage, totalCount: pageConfig.totalDatacount, pageSize: pageConfig.pagesize, onPageChange: handlePageChangeRequest })),
        addDailog && React.createElement(ClientStaffAddDailog, { showDailog: true, refressPage: function () {
                setAddDailog(false);
                fetchData();
            }, clientGuid: props.selectedClientGuuid, onClickClose: function () { return setAddDailog(false); } }),
        showConfirmation && React.createElement(ClientStaffRemoveDailog, { showDailog: true, refressPage: function () {
                setShowConfirmation(false);
                fetchData();
            }, clientGuid: props.selectedClientGuuid, clientData: clientListAccounts, onClickClose: function () { return setShowConfirmation(false); } })));
});
